import { get } from 'lodash-es'

export type SortDirection = 'asc' | 'desc'

export const collectionSortNumericFn = (propertyPath: string) => {
  return (a: any, b: any) => get(a, propertyPath, 0) - get(b, propertyPath, 0)
}

export const collectionSortStringFn = (propertyPath: string, sort: SortDirection = 'asc') => {
  return (a: any, b: any) => {
    return get(sort === 'asc' ? a : b, propertyPath, '').localeCompare(
      get(sort === 'asc' ? b : a, propertyPath, ''),
    )
  }
}
